import { Stack } from '@mui/material';

import LeftPartSkeleton from './LeftPart/skeleton';
import RightPartSkeleton from './RightPart/skeleton';

const FooterSkeleton = () => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" component="footer">
      <LeftPartSkeleton />
      <RightPartSkeleton />
    </Stack>
  );
};

export default FooterSkeleton;
